import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  helpIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  tooltip: {
    background: theme.evPalette.charcoal[800],
    fontSize: '14px',
    borderRadius: '4px',
    alignItems: 'center',
    padding: '15px',
  },
  arrow: {
    color: theme.evPalette.charcoal[800],
  },
}));
